import {useTranslation} from "react-i18next";
import {handleEmailSending} from "../../../helpers/email/emailHelper.ts";
import {fromCharCode} from "@opay/lib-core-js";

const EmailContact = () => {

    const { t } = useTranslation();

    return (
        <>
            <div>
                {t('contacts_email')}
                <a className="contact-by-email inline-contacts contact-button"
                   href="#"
                   onClick={
                    (e) => handleEmailSending(
                        e,
                        fromCharCode(105, 110, 102, 111),
                        fromCharCode(111, 112, 97, 121, 46, 101, 117)
                    )
                }>
                    {`${fromCharCode(105, 110, 102, 111, 64, 111, 112, 97, 121, 46, 101, 117)}`}
                </a>
            </div>
        </>
    )
}

export default EmailContact;
